import React from 'react';
import { SmartCaptcha, InvisibleSmartCaptcha } from '@yandex/smart-captcha';
import './SmartCaptcha.scss';
import ErrorText from '../ErrorText/ErrorText';
import { SmartCaptchaController } from './useSmartCaptcha';

interface Props {
  captcha: SmartCaptchaController;
  className?: string;
}

/**
 * CDN, с которого грузится captcha.js. По умолчанию пакет тянет его с
 * smartcaptcha.cloud.yandex.ru, но домены *.yandex.ru часто режут DNS-блокировщики
 * трекеров → скрипт не грузится, токен не выдаётся, кнопка отправки виснет.
 * smartcaptcha.yandexcloud.net отдаёт тот же виджет и в таких блок-листах почти
 * не встречается (проверено на устройстве: токен выдаётся).
 */
const CAPTCHA_HOST = 'smartcaptcha.yandexcloud.net';

/**
 * Виджет Yandex SmartCaptcha. Конфиг и состояние берёт из контроллера useSmartCaptcha.
 * Если капча не сконфигурирована/выключена — ничего не рендерит (форма не блокируется).
 */
const SmartCaptchaBox = ({ captcha, className }: Props) => {
  if (!captcha.enabled) {
    return null;
  }

  return (
    <div className={`smart-captcha-box${className ? ` ${className}` : ''}`}>
      {captcha.mode === 'invisible' ? (
        <InvisibleSmartCaptcha
          key={captcha.resetKey}
          host={CAPTCHA_HOST}
          sitekey={captcha.sitekey}
          visible={captcha.visible}
          onSuccess={captcha.onSuccess}
          onTokenExpired={captcha.onTokenExpired}
          onNetworkError={captcha.onNetworkError}
          onChallengeHidden={captcha.onChallengeHidden}
          onJavascriptError={captcha.onJavascriptError}
        />
      ) : (
        <SmartCaptcha
          key={captcha.resetKey}
          host={CAPTCHA_HOST}
          sitekey={captcha.sitekey}
          onSuccess={captcha.onSuccess}
          onTokenExpired={captcha.onTokenExpired}
          onNetworkError={captcha.onNetworkError}
          onJavascriptError={captcha.onJavascriptError}
        />
      )}
      {captcha.captchaError ? ErrorText(captcha.captchaError, true) : null}
    </div>
  );
};

export default SmartCaptchaBox;
